import { copApi } from 'api'

export interface Props {
  practitionerId: string
}

export const deleteFavouritePractitioner = ({ practitionerId }: Props) =>
  copApi.delete(`/practitioners/${practitionerId}/favourite`)
